export default {
  id: 'slack_collective_goal',
  title: 'Collective goal',
  type: 'Group',
  description: 'Current status of the collective goal.',
  body: {
    blocks: [
      {
        type: 'section',
        text: {
          type: 'mrkdwn',
          text: '[[INPUT_INTRODUCTION_TEXT]]'
        }
      },
      {
        type: 'divider'
      },
      {
        type: 'header',
        text: {
          type: 'plain_text',
          text: '{{COLLECTIVE_GOAL_ICON}} {{COLLECTIVE_GOAL_HEADLINE}}',
          emoji: true
        }
      },
      {
        type: 'section',
        text: {
          type: 'mrkdwn',
          text: '*{{COLLECTIVE_GOAL_PROGRESS}} {{COLLECTIVE_GOAL_FIRST_LINE}}* {{COLLECTIVE_GOAL_SECOND_LINE}}'
        }
      },
      {
        type: 'context',
        elements: [
          {
            type: 'mrkdwn',
            text: '🔵'
          },
          {
            type: 'mrkdwn',
            text: '🔵'
          },
          {
            type: 'mrkdwn',
            text: '🔵'
          },
          {
            type: 'mrkdwn',
            text: '🔵'
          },
          {
            type: 'mrkdwn',
            text: '⚪️'
          },
          {
            type: 'mrkdwn',
            text: '⚪️'
          },
          {
            type: 'mrkdwn',
            text: '⚪️'
          },
          {
            type: 'mrkdwn',
            text: '⚪️'
          },
          {
            type: 'mrkdwn',
            text: '⚪️'
          },
          {
            type: 'mrkdwn',
            text: '⚪️'
          }
        ]
      },
      {
        type: 'divider'
      },
      {
        type: 'section',
        text: {
          type: 'mrkdwn',
          text: '[[INPUT_END_TEXT]]'
        }
      }
    ]
  },
  inputs: {
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Hi all, ...',
      defaultValue: '<p>Hi all,</p><p>Please find the current status of our collective goal below.</p>',
      type: 'HTML'
    },
    INPUT_END_TEXT: {
      label: 'Text after collective goal',
      type: 'HTML',
      placeholder: 'Thanks for your support!',
      defaultValue: '<p>Do not forget that every activity on the platform gets us closer to reach our goal together.</p><p>If you have any questions please let me know.</p>',
    },
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/slack/collectiveGoal.js